import tile1 from "./tile1.jpg";
import tile2 from "./tile2.jpg";
import tile4 from "./tile4.jpg";
import tile5 from "./tile5.jpg";
import tile6 from "./tile6.jpg";
import tile7 from "./tile7.jpg";
// import compass from "./compass.jpg";
import tile9 from "./tile9.jpg";
import tile10 from "./tile10.jpg";
import tile11 from "./tile11.jpg";
import carpet4 from "./carpet4.jpg";
import carpet5 from "./carpet5.jpg";
import carpet3 from "./carpet3.jpg";
import hardwood from "./hardwood.jpg";
import hardwood2 from "./hardwood25bw2.jpg";
import hardwood3 from "./hardwood32.jpg";
import cabinet5 from "./cabinet6.jpg";
import metal2 from "./metal2.jpg";
import metal3 from "./metal3.jpg";
import metal4 from "./metal4.jpg";
import marble from "./marble.jpg";
import marble2 from "./marble2.jpg";
import marble3 from "./marble3.jpg";
import normalMap0 from "./normalMap10.jpg";
import normalMap1 from "./normalMap11.jpg";
import fabric1 from "./fabric1.jpg";
import fabric2 from "./fabric2.jpg";
// import envFront from "./metalEnv2.jpg";
import wallpaper1 from "./wallpaper1.jpg";
import wallpaper2 from "./wallpaper2.jpg";
export { default as top } from "./tileTop.jpg";
export { default as bottom } from "./tileBottom.jpg";
export { default as left } from "./tileLeft.jpg";
export { default as right } from "./tileRight.jpg";
export { default as topRigth } from "./tileTopRight.jpg";
export { default as bottomRight } from "./tileBottomRight.jpg";
export { default as topLeft } from "./tileTopLeft.jpg";
export { default as bottomLeft } from "./tileBottomLeft.jpg";
export { default as wall } from "./wall2_2.jpg";
export { default as nature } from "./env.jpg";
export { default as cabinet } from "./cabinet6.jpg";
export { default as molding } from "./molding.jpg";
export { default as metal } from "./metalEnv2.jpg";
export { default as marble } from "./marble.jpg";
export { default as glassT } from "./glassT3.jpg";
export { default as without } from "./without.jpg";
export { default as env } from "./nature2.hdr";
export { default as fabric } from "./fabric.jpg";
export { default as fabric3 } from "./fabric3.jpg";

export const textures = [tile1, tile2, tile4, tile5, tile6, tile7, tile9];
export const solidTextures = [carpet4, carpet5, carpet3];
export const wallTextures = [wallpaper1, wallpaper2];
export const hardwoods = [hardwood];
export const realHardwoods = [hardwood3, hardwood2];
export const woodsTextures = [cabinet5];
export const metalTextures = [metal2, metal3, metal4];
export const marbleTextures = [marble, marble2, marble3];
export const fabricTextures = [fabric1, fabric2];
export const mosaicTiles = [tile10, tile11];
export const normalMaps = [normalMap0, normalMap1];
// export const envCube = [
//     envFront,
//     envFront,
//     envFront,
//     envFront,
//     envFront,
//     envFront,
// ];
